// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.efulfill-msg {
  padding: 15px 15px 15px 45px;
  background: #6D6E70;
  margin-bottom: 10px;
  position: relative;
  font-family: "Museo-300";
  background-color: #D9D9D9;
}`, "",{"version":3,"sources":["webpack://./src/app/components/store-notification-bar/store-notification-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,4BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,yBAAA;AACJ","sourcesContent":[".efulfill-msg {\n    padding: 15px 15px 15px 45px;\n    background: #6D6E70;\n    margin-bottom: 10px;\n    position: relative;\n    font-family: \"Museo-300\";\n    background-color: #D9D9D9;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
